import { API } from "../helpers";
import { SERVER_URL } from "../config";

const BASE = `${SERVER_URL}/api/v1/partners/attribution_reports`;

const authHeaders = authToken => ({
  authentication_token: authToken,
});

export const getAttributionAvailability = authToken =>
  API.request({
    method: "get",
    url: `${BASE}/availability`,
    headers: authHeaders(authToken),
  });

export const getAttributionReport = (authToken, cycle, preview) =>
  API.request({
    method: "get",
    url: `${BASE}/${cycle}`,
    headers: authHeaders(authToken),
    params: preview ? { preview } : undefined,
  });

export const getAttributionStudents = (authToken, cycle, params) =>
  API.request({
    method: "get",
    url: `${BASE}/${cycle}/students`,
    headers: authHeaders(authToken),
    params,
  });

export const getAttributionTimeline = (
  authToken,
  cycle,
  userId,
  preview,
) =>
  API.request({
    method: "get",
    url: `${BASE}/${cycle}/students/${userId}/timeline`,
    headers: authHeaders(authToken),
    params: preview ? { preview } : undefined,
  });

export const updateAttributionConfig = (authToken, cycle, changes) =>
  API.request({
    method: "patch",
    url: `${BASE}/${cycle}/config`,
    headers: authHeaders(authToken),
    data: changes,
  });

export const createAttributionNextStep = (authToken, cycle, step) =>
  API.request({
    method: "post",
    url: `${BASE}/${cycle}/next_steps`,
    headers: authHeaders(authToken),
    data: { action_text: step.action, context: step.context },
  });

export const updateAttributionNextStep = (
  authToken,
  cycle,
  id,
  changes,
) =>
  API.request({
    method: "patch",
    url: `${BASE}/${cycle}/next_steps/${id}`,
    headers: authHeaders(authToken),
    data: { action_text: changes.action, context: changes.context },
  });

export const deleteAttributionNextStep = (authToken, cycle, id) =>
  API.request({
    method: "delete",
    url: `${BASE}/${cycle}/next_steps/${id}`,
    headers: authHeaders(authToken),
  });

export const reorderAttributionNextSteps = (
  authToken,
  cycle,
  orderedIds,
) =>
  API.request({
    method: "patch",
    url: `${BASE}/${cycle}/next_steps/reorder`,
    headers: authHeaders(authToken),
    data: { ordered_ids: orderedIds },
  });
